module.exports = __webpack_public_path__ + "img/btn_shitu_zuo.62a91719.png";